export default __webpack_public_path__ + "static/media/pending-transaction.06dc75bd.svg";